module.exports = function() {
  return new Worker("https://app.groovehq.com/2021-06-05-22-36-42-9db322d0d/" + "chat-sw.js");
};